module.exports = __webpack_public_path__ + "static/media/29BDOS25.435f7130.jpg";